// extracted by mini-css-extract-plugin
module.exports = {"layout":"logo-grid_layout__2oCBU"};